import { ICenter, IProductCenter, IProductCenterContact, IContact } from "./";
import { ICommunicationLog } from "./communication-log";

export interface ICrmProductPlan {
    center: ICenter,
    productCenter: IProductCenter,
    productCenterContacts: IProductCenterContact[],
    communicationLogs: ICommunicationLog[],
    centerContacts: IContact[],
    nkrContacts: IContact[]
}